<template>
   <div class="absolute top-0 left-0 mt-16 w-screen h-auto p-4 border border-black bg-slate-700 z-[1200]">
    <h1>IMAGES</h1>
    <ul class="flex flex-wrap gap-4">
        <li><button @click="$emit('cancel')" class="bg-slate-500 text-red-400 m-2 p-2">cancel</button></li>
        <li v-for="i in images" :key="i.id"><img @click="selectImage(i)" :src="buildPath(i)" :alt="i.title" />{{i.id}}</li>
    </ul>
   </div>
</template>

<script>
import { api } from '@/api';
export default {
   name: "ImageList",
   computed: {},
   data() {
       return {
           images: [],
           size: '320x120'
       }
   },
   mounted() {
        this.getImages();
   },
   methods: {
        getImages() {
            api.get('/images')
            .then(d => {
                this.images=d.data;
            })
        },
        buildPath(i) {
            if(!i) return;
            return `/storage/webp/${i.filename}-${this.size}.webp`;
        },
        selectImage(i) {
            this.$emit('imageSelected', i);
        }
   }
}
</script>
